// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowsMaximize16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrows-maximize': IconArrowsMaximize;
    }
}

/**
 * The icon component for the 'arrowsMaximize' icon
 */
export class IconArrowsMaximize extends Icon {
    public constructor() {
        super(arrowsMaximize16X16);
    }
}

registerIcon('icon-arrows-maximize', IconArrowsMaximize);
export const iconArrowsMaximizeTag = 'nimble-icon-arrows-maximize';
